import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { WaybillIdView } from '../../../../models/shipment-id-view.model';
import { API_URL } from '../../../../../services/config';
import { ShipmentWaybillEndpoint } from '../../constants/shipment-waybill-endpoint';
import { Observable } from 'rxjs';
import { ShipmentWaybillEdit, ShipmentWaybillOverview } from '../../models/shipment-waybill.model';
import { getQueryStringFromObject } from '../../../../../common/utils';

@Injectable({ providedIn: 'root' })
export class ShipmentWaybillMainInfoService {
  constructor(private http: WrapperHttpService) {}

  getOverviewData(waybillIdView: WaybillIdView): Observable<ShipmentWaybillOverview> {
    const url = `${API_URL}${ShipmentWaybillEndpoint.Base}${ShipmentWaybillEndpoint.Waybills}${
      ShipmentWaybillEndpoint.Summary
    }?${getQueryStringFromObject({
      ...waybillIdView,
    })}`;

    return this.http.withLoading().get(url);
  }

  updateOverviewData(id: string, data: ShipmentWaybillEdit): Observable<null> {
    const url = `${API_URL}${ShipmentWaybillEndpoint.Base}${ShipmentWaybillEndpoint.Waybills}${
      ShipmentWaybillEndpoint.Adaptation
    }?${getQueryStringFromObject({
      internalWaybillId: id,
    })}`;

    return this.http.withLoading().patch(url, data);
  }
}
